const state = () => ({
  warningModalText: "",
  warningModalTitle: "",
  warningModalToolTipTextYes: "",
  warningModalToolTipTextNo: "",
  warningModalVisible: false,
});

const mutations = {
  openWarningModal(state) {
    state.warningModalVisible = true;
  },
  closeWarningModal(state) {
    state.warningModalVisible = false;
  },
  setWarningModalText(state, val) {
    state.warningModalText = val;
  },
  setWarningModalTitle(state, val) {
    state.warningModalTitle = val;
  },
  setWarningModalTooltipText(state, valYes, valNo) {
    state.warningModalToolTipTextYes = valYes;
    state.warningModalToolTipTextNo = valNo;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
